import React from 'react';
import styled, { css } from 'styled-components';
import { Handle } from 'reactflow';
import { themeColor } from '../../theme/colors';

export const CustomHandle = styled(Handle)<{ $hidden?: boolean }>`
  border: none;
  outline: none;
  background-color: ${themeColor({
    dark: 'turquoise',
    light: 'turquoiseTertiary',
  })} !important;
  left: 3px;
  width: 4px !important;
  ${({ $hidden }) =>
    $hidden &&
    css`
      visibility: hidden;
    `}
`;

export const HandleRightInvisible = styled(Handle)`
  opacity: 0;
  right: 0;
`;
